import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import AppButton from "@nxsys/components/AppButton";
import AppInputSearch from "@nxsys/components/AppInputSearch";
import { StyledFlex } from "./index.styled";
import { useIntl } from "react-intl";


type KIDContentHeaderPropsTypes = {
  isFilterStatus?: boolean;
  isCreate?: boolean;
  onToggleCreate?: () => void;
  onChangeStatus?: (value: string) => void;
  onChangeSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const KIDContentHeader = (props: KIDContentHeaderPropsTypes) => {
  const {
    isCreate = false,
    onToggleCreate = () => {},
    onChangeSearch = () => {},
  } = props;
const { messages } = useIntl();
  const [searchTerm, setSearchTerm] = useState<string>("");

  const onChangeSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onChangeSearch(e);
  };


  return (
    <>
      <StyledFlex>
        <div style={{ marginRight: 12 }}>
          <AppInputSearch
            value={searchTerm}
            onChange={onChangeSearchTerm}
          />
        </div>
        {isCreate && (
          <AppButton
            type="primary"
            name={messages["common.sendEmail"] as string}
            variant= "outlined"
            className="btn-add-new"
            icon={
              <PlusOutlined />
            }
            onClick={onToggleCreate}
          />
        )
      }
      </StyledFlex>
    </>
  );
};

export default KIDContentHeader;
